<template>
  <Modal name="HAUSEFUL_INVOICE_UPLOAD_MODAL" :title="title" :width="480">
    <template v-slot:body>
      <div v-if="!hausefulInvoiceInfo.id" class="invoice-upload">
        <h6 class="text-uppercase grey--text">
          {{ $t('hausefulInvoices.realEstate') }}
        </h6>
        <p v-if="hausefulInvoiceInfo.realEstate" class="body-2">
          {{ hausefulInvoiceInfo.realEstate }}
          <small v-if="hausefulInvoiceInfo.cnpj && !hausefulInvoiceInfo.branchCnpj" class="d-block grey--text">
            {{ formatDocument(hausefulInvoiceInfo.cnpj) }}
          </small>
        </p>

        <div v-if="hausefulInvoiceInfo.branch" class="mb-8">
          <h6 class="text-uppercase grey--text">
            {{ $t('hausefulInvoices.subsidiary') }}
          </h6>
          <p class="body-2">
            {{ hausefulInvoiceInfo.branch }}
            <small v-if="hausefulInvoiceInfo.branchCnpj" class="d-block grey--text">
              {{ formatDocument(hausefulInvoiceInfo.branchCnpj) }}
            </small>
          </p>
        </div>
      </div>

      <div v-else class="invoice-upload--edit">
        <v-row>
          <v-col cols="12" sm="4">
            <h6 class="text-uppercase grey--text">
              {{ $t('hausefulInvoices.modals.upload.createdAt') }}
            </h6>
            <span class="caption">
              {{ formatDate(hausefulInvoiceInfo.created_at) }}
            </span>
          </v-col>
          <v-col cols="12" sm="8">
            <h6 class="text-uppercase grey--text">
              {{ $t('hausefulInvoices.modals.upload.file') }}
            </h6>
            <v-btn
              v-if="hausefulInvoiceInfo.file_response"
              :href="hausefulInvoiceInfo.file_response.url"
              target="_blank"
              color="primary"
              elevation="0"
              small
            >
              <v-icon left small>
                mdi-download
              </v-icon>
              <span class="mw-200 caption text-truncate">
                {{ $t('hausefulInvoices.modals.upload.download') }}
                {{ hausefulInvoiceInfo.file_response.name }}
              </span>
            </v-btn>
            <span v-else>---</span>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <h6 class="text-uppercase grey--text">
              {{ $t('hausefulInvoices.modals.upload.createdBy') }}
            </h6>
            <span class="caption">
              {{ hausefulInvoiceInfo.created_by
                ? hausefulInvoiceInfo.created_by.name
                : $t('hausefulInvoices.emittedOutsideThePlatform') }}
            </span>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <h6 class="text-uppercase grey--text">
              {{ $t('hausefulInvoices.modals.upload.client') }}
            </h6>
            <span class="caption">
              {{ hausefulInvoiceInfo.real_estate.name }}
            </span>
          </v-col>
        </v-row>

        <v-row v-if="hausefulInvoiceInfo && hausefulInvoiceInfo.branch" >
          <v-col>
            <h6 class="text-uppercase grey--text">
              {{ $t('hausefulInvoices.modals.upload.branch') }}
            </h6>
            <p class="body">
              {{ hausefulInvoiceInfo.branch.name }}
              <small v-if="
                hausefulInvoiceInfo &&
                hausefulInvoiceInfo.branch &&
                hausefulInvoiceInfo.branch.cnpj"
                class="d-block grey--text"
              >
                {{ formatDocument(hausefulInvoiceInfo.branch.cnpj) }}
              </small>
            </p>
          </v-col>
        </v-row>
      </div>

      <div v-if="hausefulInvoiceInfo.id">
        <v-divider class="mt-2 mb-6" />
        <h6 class="text-uppercase grey--text">
          {{ $t('hausefulInvoices.modals.upload.addFileToUpdate') }}
        </h6>
      </div>

      <!-- upload -->
      <HUploading v-if="hausefulInvoiceFileLoading" class="mb-4" />
      <HUpload
        @change="handleGetFile"
        class="mt-0 mb-2"
        multiple
        small
      />
      <!-- /upload -->
    </template>
  </Modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { formatDocument } from '@/util/document'
import { catalogDate } from '@/util/catalog'

import Modal from '@/components/app/Modal'
import HUpload from '@/components/lib/HUpload'
import HUploading from '@/components/app/HUploading'

export default {
  name: 'ModalHausefulTakeRateUpload',

  components: {
    Modal,
    HUpload,
    HUploading,
  },

  data() {
    return {
      formatDocument,
      formatDate: catalogDate,
    }
  },

  computed: {
    ...mapGetters([
      'hausefulInvoiceData',
      'hausefulInvoiceInfo',
      'hausefulInvoiceFileLoading',
    ]),

    title() {
      return this.hausefulInvoiceInfo.id
        ? this.$t('hausefulInvoices.modals.upload.titleUpdate')
        : this.$t('hausefulInvoices.modals.upload.title')
    },
  },

  methods: {
    ...mapActions([
      'attachHausefulTakeRateInvoiceFiles',
      'attachHausefulTakeRateInvoiceFilesUpdate',
    ]),

    handleGetFile(file) {
      if (!this.hausefulInvoiceInfo.id) {
        this.attachHausefulTakeRateInvoiceFiles(file)
      } else {
        this.attachHausefulTakeRateInvoiceFilesUpdate(file)
      }
    },
  },
}
</script>
